export type ActionConstant = 'order/fetchAsync';

export class ActionConstants {
    public static readonly fetch: string = 'order/fetchAsync';
    public static readonly updateFilterStatus: string = 'order/updateFilterStatus';
    public static readonly updatePage: string = 'order/updatePage';
    public static readonly updateFrom: string = 'order/updateFrom';
    public static readonly updateTo: string = 'order/updateTo';
}
